export const fontSpecs = {
  size: 12,
}
